import { useContext } from 'react';
import { SidenavContext } from '../components/context/SideNavContextProvider';

const useToggleSideNav = () => {
  const { show, showSideNav, hideSideNav } = useContext(SidenavContext);
  return {
    show,
    showSideNav,
    hideSideNav,
  };
};

export default useToggleSideNav;
